<style lang="stylus" scoped>
@import '../../cardMap/cardMap.stylus';

.listFather {
  position: relative;

  .ul {
    position: absolute;
    bottom: 0;
    left: 0;
    border: 1px solid #ced3de;
    z-index: 20;
  }
}

li {
  list-style: none;
  height: 36px;
  line-height: 36px;
  padding-left: 15px;
  cursor: pointer;

  &:hover {
    background: #f2f2f2;
  }
}
</style>
<template>
  <div class="home-main">
    <div class="map-search radius-5 b1 p-2">
      <el-row style="line-height: 76px;font-size: 18px;color: #336db0;"></el-row>
      <el-form
        :inline="true"
        :model="option"
        class="demo-form-inline"
        style="margin-left:13px;margin-top:25px;"
      >
        <el-form-item label="网点编码">
          <el-input v-model.trim.number="option.siteCode" placeholder="网点编码"></el-input>
        </el-form-item>
        <el-form-item label="网点名称">
          <el-input v-model.trim="option.siteName" placeholder="网点名称" style="width:220px;"></el-input>
          <div
            class="ul"
            v-if="searchBlock"
            style="border:1px solid #ced3de;position:fixed;z-index:10;width:220px;background:#fff;border-top-color:transparent;"
          >
            <li
              v-for="(item, index) in list"
              :key="index"
              @click="editSearch(item)"
            >{{item.siteName}}</li>
          </div>
        </el-form-item>
        <el-form-item label="日期选择">
          <el-date-picker
            :clearable="false"
            v-model="option.timeSection"
            
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button @click="goBack">返回上级</el-button>
        </el-form-item>
      </el-form>
    </div>
    <TableDate :dataAll="totalCount" :name="totalCount?totalCount.name:null"/>
  </div>
</template>

<script>
import TableDate from '../components/tableDate' //表格数据
import http1 from '@/api/cardData'
import Cookies from 'js-cookie'
import http from '@/api/consump.js' //请求汇总
export default {
  components: {
    TableDate
  },
  data() {
    return {
      option: {
        timeSection: [
          new Date(new Date() * 1 - 30 * 24 * 3600 * 1000) * 1,
          new Date(new Date() * 1 - 1 * 24 * 3600 * 1000) * 1
        ],
        siteCode: null,
        siteName: null,
        siteCode1: null
      },
      list: [], //模糊搜索的数据
      searchBlock: false,
      totalCount: [], //查询的结果集
      cityItem: []
    }
  },
  created() {
    this.option.timeSection = JSON.parse(this.$route.query.timeSection)
      ? JSON.parse(this.$route.query.timeSection)
      : this.option.timeSection
    this.option.siteCode = this.$route.query.siteCode
      ? this.$route.query.siteCode
      : this.option.siteCode
    this.option.siteName = this.$route.query.siteName
      ? this.$route.query.siteName
      : this.option.siteName
    this.onSubmit()
  },
  watch: {
    'option.siteName': function(value, oldValue) {
      let that = this;
      that.searchBlock = false
      if(value.length>=1){
        let _option = {
        siteName: value,
        phone: Cookies.get('user')
      }
      http1[0].searchSiteDate(_option).then(e => {
        that.list = e.data.clist||[]
        if(that.list.length>1) that.searchBlock = true
      })
      }else{
        that.list = []
      }
    }
  },
  computed: {},
  methods: {
    goBack() {
      this.$router.replace({
        name: 'consumpSite'
      })
    },
    onSubmit() {
      let that = this
      let _option = {
        timeSection: that.option.timeSection
      }
      if (this.option.siteCode && (this.option.siteCode + '').length != 8) {
        this.$notify.error({
          title: '错误',
          message: '请输入正确的网点编码'
        })
        return
      }
      if (this.option.siteCode && this.option.siteCode1) {
        if (this.option.siteCode != this.option.siteCode1) {
          this.$notify.error({
            title: '错误',
            message: '网点名称与网点编码不一致，请重新输入'
          })
          return
        }
      }
      if (this.option.siteCode || this.option.siteCode1) {
        _option.siteCode = this.option.siteCode || this.option.siteCode1
        http
          .searchData({
            timeSection: this.option.timeSection,
            siteCode: this.option.siteCode
          })
          .then(e => {
            let data = e.data
            that.totalCount = data[0]
          })
      }
    },
    init() {},
    editSearch(item) {
      this.option.siteName = item.siteName
      this.searchBlock = false
      this.option.siteCode1 = item.siteCode
    },
    searchEvent(it) {
      this.searchItem.forEach(e => {
        e.selected = false
      })
      it.selected = true
    }
  },
  mounted() {
    this.init()
  }
}
</script>
